import s from "./notifications.svg";
import defaultAvatartSrc from "./default-avatar.svg";
import logoSrc from "./logo.svg";
import knowledgeSrc from "./knowledge.svg";
import knowledgeOffSrc from "./knowledge-off.svg";
import pencilEditSrc from "./pencil-edit.svg";
import pencilSignSrc from "./pencil-sign.svg";
import finishPrimarySrc from "./finish-primary.svg";
import finishSecondarySrc from "./finish-secondary.svg";
import rightSecondarySrc from "./arrow-right-secondary.svg";
import rightTertiarySrc from "./arrow-right-tertiary.svg";
import rightSrc from "./arrow-right.svg";
import reset from "./reset.svg";
import ovalActiveSrc from "./oval-active.svg";
import ovalPausedSrc from "./oval-paused.svg";
import playSrc from "./play.svg";

export const SvgIconUpload = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 48 48" fill="currentColor">
            <path d="M12.5 40q-4.3 0-7.4-3.1Q2 33.8 2 29.5q0-3.9 2.475-6.875t6.375-3.575q1-4.85 4.7-7.925T24.1 8.05q5.65 0 9.475 4.075Q37.4 16.2 37.4 21.9v1.2q3.6-.1 6.1 2.325Q46 27.85 46 31.55q0 3.45-2.5 5.95T37.55 40H25.5q-1.2 0-2.1-.9-.9-.9-.9-2.1V24.1l-4.15 4.15-2.15-2.15 7.8-7.8 7.8 7.8-2.15 2.15-4.15-4.15V37h12.05q2.25 0 3.85-1.6t1.6-3.85q0-2.25-1.6-3.85t-3.85-1.6H34.4v-4.2q0-4.45-3.025-7.65t-7.475-3.2q-4.45 0-7.5 3.2t-3.05 7.65h-.95q-3.1 0-5.25 2.175T5 29.45q0 3.1 2.2 5.325T12.5 37h7v3ZM24 25.5Z" />
        </svg>
    );
};

export const SvgIconClose = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <g stroke="#FFF" strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="square">
                <path d="M13.882 14.173 1.86 2.153M1.86 14.173l12.021-12.02" />
            </g>
        </svg>
    );
};
export const SvgIconSave = () => {
    return (
        <svg
            width="20"
            height="15"
            viewBox="0 0 20 15"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <filter
                    x="-20.7%"
                    y="-15.4%"
                    width="141.4%"
                    height="130.9%"
                    filterUnits="objectBoundingBox"
                    id="60vfbym4ib"
                >
                    <feOffset dy="4" in="SourceAlpha" result="shadowOffsetInner1" />
                    <feComposite
                        in="shadowOffsetInner1"
                        in2="SourceAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                        result="shadowInnerInner1"
                    />
                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" in="shadowInnerInner1" />
                </filter>
                <path
                    d="M1 0h11.787l-.085 7.829-2.49 2.82v5.51a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z"
                    id="vsusl5tgla"
                />
            </defs>
            <g fill="none" fillRule="evenodd">
                <g strokeLinejoin="round" transform="rotate(-90 7.771 6.167)">
                    <use fill="#D5DFFE" xlinkHref="#vsusl5tgla" />
                    <use fill="#000" filter="url(#60vfbym4ib)" xlinkHref="#vsusl5tgla" />
                    <use stroke="#111C5B" strokeWidth="1.3" xlinkHref="#vsusl5tgla" />
                </g>
                <path stroke="#111C5B" strokeWidth="1.3" d="M18.686 8.794h-8.08" />
            </g>
        </svg>
    );
};

export const SvgIconBack = () => {
    return (
        <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(.53 .643)" fillRule="nonzero" fill="none">
                <circle fill="#2D5FFB" cx="8.998" cy="8.998" r="8.998" />
                <path
                    d="m10.663 11.744-3.33-2.746 3.33-2.745"
                    stroke="#FFF"
                    strokeLinejoin="round"
                    strokeWidth="1.65"
                />
            </g>
        </svg>
    );
};
export const SvgIconForward = () => {
    return (
        <svg width="19" height="20" viewBox="0 0 19 20" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(.548 .476)" fillRule="nonzero" fill="none">
                <ellipse
                    fill="#FFF"
                    opacity=".253"
                    transform="matrix(-1 0 0 1 17.996 0)"
                    cx="8.998"
                    cy="9.429"
                    rx="8.998"
                    ry="9.429"
                />
                <path d="m7.333 12.306 3.33-2.877-3.33-2.877" stroke="#FFF" strokeLinejoin="round" strokeWidth="1.65" />
            </g>
        </svg>
    );
};

export const SvgIconFinishDraft = ({ width, height }: { width: string; height: string }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 333 217" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient x1=".187%" y1="17.542%" x2="64.263%" y2="65.745%" id="wxkq6ofy8a">
                    <stop stopColor="#FF928E" offset="0%" />
                    <stop stopColor="#FEB3B1" offset="100%" />
                </linearGradient>
                <linearGradient x1="29.325%" y1="-16.93%" x2="55.92%" y2="82.466%" id="m0i9wch32b">
                    <stop stopColor="#FF928E" offset="0%" />
                    <stop stopColor="#FEB3B1" offset="100%" />
                </linearGradient>
                <linearGradient x1="33.745%" y1="-16.93%" x2="54.654%" y2="82.466%" id="hlgecka7vc">
                    <stop stopColor="#FF928E" offset="0%" />
                    <stop stopColor="#FEB3B1" offset="100%" />
                </linearGradient>
                <linearGradient x1="37.08%" y1="-16.93%" x2="53.699%" y2="82.466%" id="hxxfan3u1d">
                    <stop stopColor="#FF928E" offset="0%" />
                    <stop stopColor="#FEB3B1" offset="100%" />
                </linearGradient>
                <linearGradient x1="34.548%" y1="-16.93%" x2="54.424%" y2="82.466%" id="kwhugm98ze">
                    <stop stopColor="#FF928E" offset="0%" />
                    <stop stopColor="#FEB3B1" offset="100%" />
                </linearGradient>
            </defs>
            <g fill="none" fillRule="evenodd">
                <path
                    d="M71.73 1.126C28.05 9.476 3.775 67.595 27.396 123.62c23.62 56.027 86.55 103.762 167.1 84.571 80.55-19.19 103.462-75.428 92.006-113.524-11.455-38.097-42.697-59.832-70.983-59.832-2.989 0-5.989.107-9 .322l-1.506.117c-29.064 2.417-58.066-5.169-81.143-21.224C106.67 2.077 89.287-2.231 71.73 1.126z"
                    fill="#EFF3FD"
                    fillRule="nonzero"
                />
                <path
                    d="M70.1 167.926c-.015-.03-.027-.057-.043-.085.023.043.035.07.042.085z"
                    fill="#3C7219"
                    fillRule="nonzero"
                />
                <g transform="matrix(-1 0 0 1 215.191 45.45)">
                    <path
                        d="M116.677 142.87 0 142.906V11.072C0 4.957 4.584 0 10.239 0h125.944l-10.238 13.91v120.525a8.472 8.472 0 0 1-9.268 8.434z"
                        fill="#FFF"
                        fillRule="nonzero"
                    />
                    <path
                        d="M145.894 50.802h-19.866V10.863c0-5.932 4.447-10.741 9.933-10.741s9.933 4.809 9.933 10.741v39.94z"
                        fill="#BDCCF9"
                    />
                    <path
                        fill="#162371"
                        d="M76.596 21.406h27.301V19.76H76.596zM93.331 36.098h10.566v-1.647H93.331zM45.88 36.098h41.807v-1.647H45.88zM45.88 50.79h18.115v-1.647H45.88zM69.113 50.79h34.784v-1.647H69.113z"
                    />
                    <path d="M106.162 117.28c0 8.15 3.415 16.97 10.245 26.464H1.52L0 117.28h106.162z" fill="#BDCCF9" />
                    <circle fill="#FFF" fillRule="nonzero" cx="112.419" cy="130.134" r="13.61" />
                    <circle fill="#BDCCF9" cx="30.495" cy="135.155" r="8.588" />
                </g>
                <path
                    stroke="#162371"
                    strokeWidth=".81"
                    strokeDasharray="1.619999957084656,1.619999957084656"
                    d="M332.3 189.597H1.026"
                />
                <g fillRule="nonzero">
                    <path fill="#E3B70F" d="m152.3 134.347 3.226-1.416 1.53 3.173 5.515-14.93-4.757-1.757z" />
                    <path fill="#E3B70F" d="m170.218 134.347-3.226-1.416-1.53 3.173-5.515-14.93 4.757-1.757z" />
                    <path
                        d="M160.097 107.563a1.814 1.814 0 0 0-2.867.768 1.814 1.814 0 0 1-2.013 1.162 1.815 1.815 0 0 0-2.098 2.098c.15.864-.34 1.71-1.163 2.013a1.814 1.814 0 0 0-.768 2.867 1.814 1.814 0 0 1 0 2.324 1.814 1.814 0 0 0 .768 2.867 1.815 1.815 0 0 1 1.163 2.013 1.815 1.815 0 0 0 2.098 2.098c.863-.15 1.71.34 2.013 1.162a1.814 1.814 0 0 0 2.867.767 1.814 1.814 0 0 1 2.324 0 1.814 1.814 0 0 0 2.867-.767 1.814 1.814 0 0 1 2.013-1.162 1.814 1.814 0 0 0 2.098-2.098c-.15-.864.34-1.71 1.162-2.013a1.814 1.814 0 0 0 .768-2.867 1.814 1.814 0 0 1 0-2.324 1.814 1.814 0 0 0-.768-2.867 1.815 1.815 0 0 1-1.163-2.013 1.814 1.814 0 0 0-2.097-2.098 1.814 1.814 0 0 1-2.014-1.162 1.815 1.815 0 0 0-2.866-.768 1.814 1.814 0 0 1-2.324 0z"
                        fill="#FCCB11"
                    />
                </g>
                <g fillRule="nonzero">
                    <path
                        d="M87.35 146.266a20.457 20.457 0 0 1-12.877-12.841l-.018-.053a19.337 19.337 0 0 1-12.546 12.781l-.349.113a17.628 17.628 0 0 1 12.74 12.341l.155.554.298-.952a17.834 17.834 0 0 1 12.597-11.943z"
                        fill="#2D5FFB"
                    />
                    <path
                        d="M95.98 131.053a11.82 11.82 0 0 1-7.44-7.42l-.01-.03a11.173 11.173 0 0 1-7.25 7.385l-.2.065a10.185 10.185 0 0 1 7.36 7.13l.09.32.172-.55a10.304 10.304 0 0 1 7.278-6.9z"
                        fill="#BDCCF9"
                    />
                    <path
                        d="M66.217 133.372a7.387 7.387 0 0 1-4.65-4.638l-.007-.019a6.983 6.983 0 0 1-4.53 4.616l-.127.04a6.366 6.366 0 0 1 4.6 4.457l.057.2.108-.344a6.44 6.44 0 0 1 4.549-4.312zM263.338 39.42a7.387 7.387 0 0 1-4.65-4.637l-.006-.02a6.983 6.983 0 0 1-4.53 4.616l-.127.041a6.366 6.366 0 0 1 4.6 4.457l.057.2.108-.344a6.44 6.44 0 0 1 4.548-4.313z"
                        fill="#FCCB11"
                    />
                </g>
                <g fillRule="nonzero">
                    <path
                        d="M26.733 151.165c-3.911.522-7.783 1.3-11.592 2.33-2.167.66-3.897-2.15-6.436-1.915-2.538.235-1.527 5.597-2.706 7.568-1.18 1.97-4.774 7.523-4.01 8.956.764 1.433 1.37-1.545 6.155-5.351 4.785-3.807 9.075-2.687 9.075-2.687s2.842.436 7.088 1.007c0-.257 0-.526.067-.783a39.639 39.639 0 0 1 2.359-9.125z"
                        fill="url(#wxkq6ofy8a)"
                        transform="translate(163.962 31.633)"
                    />
                    <path
                        d="M74.3 155.095a55.89 55.89 0 0 1-5.616 7.837c-1.505 1.701-4.661 1.332-6.189 3.358-1.528 2.027 1.91 5.777 2.572 7.949.663 2.172.966 8.822 2.527 9.203 1.562.38 2.505-3.202 2.853-9.293.348-6.09 4.055-8.53 4.055-8.53s2.404-2.038 5.885-5.083a23.415 23.415 0 0 1-6.087-5.441z"
                        fill="url(#m0i9wch32b)"
                        transform="translate(163.962 31.633)"
                    />
                    <path
                        d="M270.8 165.849c-1.28 3.918-17.442 18.472-26.394 26.309a23.408 23.408 0 0 1-4.212-3.27 13.307 13.307 0 0 1-.843-.873c-.381-.403-.74-.828-1.123-1.265 5.156-8.34 9.626-17.464 18.207-19.591a150.803 150.803 0 0 1-36.155-14.017c.258.694.516 1.4.775 2.15 5.413 16.188 9.097 36.43 4.223 39.407-3.56 2.183-25.508-.425-37.065-1.993 0-.257 0-.515.067-.783.191-1.582.503-3.146.932-4.68.101-.403.225-.806.337-1.21.326-1.119.697-2.149 1.123-3.212 7.863-1.12 17.904-1.534 24.43 1.646 0 0-15.276-23.656-15.534-42.352 0 0 2.898-5.99 7.862-4.87 0 0 3.168.716 6.863 5.172a3.957 3.957 0 0 1 1.056-1.12 9.937 9.937 0 0 1 11.86-3.448c16.13 5.967 45.715 21.518 43.592 28zM168.95 186.258c-.337 1.12-.348 2.239-.708 3.358a15.665 15.665 0 0 1-2.403 3.874 9.027 9.027 0 0 0-1.876 5.273 3.038 3.038 0 0 0 .45 1.657c.058.095.13.181.213.257.244.26.548.457.887.571h.101l.236.056h1.224c.164-.032.326-.077.483-.134a5.452 5.452 0 0 0 2.55-2.306c.157-.247.314-.504.46-.762.4-.77.843-1.517 1.326-2.239a8.79 8.79 0 0 1 1.887-1.925 9.28 9.28 0 0 1 .685-.47c.298-.187.61-.351.932-.493.202-.097.404-.187.606-.269.415-.15.84-.273 1.27-.37.528-.111 1.18-.134 1.415-.67.091-.228.133-.473.123-.717 0-.403 0-.829-.056-1.12a1.474 1.474 0 0 0-.224-.873 1.328 1.328 0 0 0-1.19-.358c-.426.06-.857.06-1.281 0a5.885 5.885 0 0 1 .775-2.855c.195-.343.31-.726.337-1.12a.972.972 0 0 0-.124-.459 1.293 1.293 0 0 0-.966-.526l-.606-.078h-.101c-.652-.09-1.292-.336-1.932-.482h-.057a3.594 3.594 0 0 0-.763-.112h-.304l-.37.056a3.271 3.271 0 0 0-1.37.773 5.663 5.663 0 0 0-1.63 2.463zM226.289 202.681c.516 1.02 1.325 1.859 1.83 2.889.538 1.439.871 2.946.989 4.478a8.943 8.943 0 0 0 2.325 5.083c.405.428.923.734 1.494.884.108.01.217.01.325 0 .358.02.714-.054 1.034-.213h.1l.214-.123.202-.134.18-.146.191-.179.202-.224.113-.157c.09-.134.18-.28.258-.425a5.48 5.48 0 0 0 .202-3.426 10.703 10.703 0 0 0-.202-.862 25.835 25.835 0 0 1-.607-2.53 9.05 9.05 0 0 1 0-2.698c0-.269.102-.537.169-.817.088-.338.193-.67.314-.997.079-.201.169-.414.259-.604.187-.39.405-.764.651-1.12.292-.448.753-.918.54-1.466a1.858 1.858 0 0 0-.405-.594c-.28-.302-.618-.57-.842-.795a1.607 1.607 0 0 0-.787-.459 1.327 1.327 0 0 0-1.123.56c-.252.345-.555.65-.898.907a5.962 5.962 0 0 1-1.45-2.586 2.494 2.494 0 0 0-.56-1.064.877.877 0 0 0-.416-.246c-.4-.077-.812.03-1.124.291l-.483.37h-.09c-.527.391-1.123.66-1.718.996-.22.13-.426.28-.618.448a1.962 1.962 0 0 0-.213.224c-.088.089-.167.186-.236.29a3.25 3.25 0 0 0-.45 1.512 5.638 5.638 0 0 0 .63 2.933zM206.768 73.386c.92-.615 1.988-1.018 2.864-1.701.858-.8 1.66-1.657 2.403-2.564 1.13-1.199 3.042-5.012 4.678-5.216 4.06 0 5.05 7.106 4.948 8.384-.062.947-.25 1.88-.561 2.777-.183.814-.3 1.641-.349 2.474a2.872 2.872 0 0 1-2.392 2.16c-1.393.225-2.134-.649-3.37-.839a4.781 4.781 0 0 0-2.954 1.243c-1.123.985-1.448 2.552-2.437 3.638a4.129 4.129 0 0 1-3.28 1.321c-2.313-.235-2.583-3.773-2.628-5.463a7.424 7.424 0 0 1 .708-3.47 7.004 7.004 0 0 1 2.37-2.744z"
                        fill="#111C5B"
                    />
                    <path
                        d="M50.803 42.123a5.045 5.045 0 0 1 3.796.772 6.44 6.44 0 0 1 1.91 4.053c1.078 6.785-.854 10.736-3.853 11.52a8.07 8.07 0 0 1-.296.047c.177 1.526.594 3.276 1.543 4.308a5.823 5.823 0 0 0 1.797 1.59c.438.235-.315 3-.472 3.302a5.606 5.606 0 0 1-2.572 2.676c-.76.343-1.6.463-2.426.347a4.088 4.088 0 0 1-.483-.112c-3.123-.84-5.055-4.276-6.043-7.03.456-.525.77-1.157.91-1.836a16.531 16.531 0 0 0-1.061-6.855c-.14-.028-.314-.025-.557.003a2.249 2.249 0 0 1-2.021-1.019 4.098 4.098 0 0 1-.584-2.239 2.724 2.724 0 0 1 .213-1.231c.2-.437.642-.714 1.123-.706.427 0 1 .347 1.314 0 .315-.347.315-.884.315-1.31.067-.485.2-.96.393-1.41a6.72 6.72 0 0 1 1.864-2.418 11.765 11.765 0 0 1 5.19-2.452z"
                        fill="url(#hlgecka7vc)"
                        transform="translate(163.962 31.633)"
                    />
                    <path
                        d="M21.431 13.642c.191-2.608.36-4.299.36-4.299s4.178-7.669.37-9.18C18.354-1.35 18.31 8.156 18.31 8.156s-.64 1.948-1.494 4.937c1.554.021 3.101.205 4.616.549z"
                        fill="url(#hxxfan3u1d)"
                        transform="translate(163.962 31.633)"
                    />
                    <path
                        d="M95.944 63.517c-3.426-.683-4.774 8.24-4.774 8.24-.337.806-.988 2.138-1.808 3.728 1.565.547 3.05 1.3 4.414 2.24.91-3.248 1.426-5.475 1.426-5.475s4.167-8.005.742-8.733z"
                        fill="url(#kwhugm98ze)"
                        transform="translate(163.962 31.633)"
                    />
                    <path
                        d="M253.324 107.073c-3.089 6.023-8.559 15.864-8.559 15.864-7.2-23.7-16.106-25.066-18.499-25.548-1.65-.336-5.75-1.455-6.447-.828-.696.627-.842 2.172-1.348 2.9a4.773 4.773 0 0 1-3.01 2.126 5.625 5.625 0 0 1-4.627-1.914c-.382-.37-3.662-4.053-3.1-4.568a1.35 1.35 0 0 1-.843.415l-.561.067s-10.94-6.493-20.218-22.839c-2.179-3.85-1.314-19.726-.741-27.473a22.218 22.218 0 0 0-4.616-.549c-2.247 7.68-5.841 22.28-3.988 28.795 2.572 9.068 19.903 37.27 19.914 37.258l.135 1.567c1.034 10.289.46 20.768.416 31.112 0 2.452-.101 12.718 4.672 10.983 1.45-.527 2.381-1.881 3.37-3 3.089-3.36 7.593-4.938 11.973-6.125 4.38-1.186 8.986-2.115 12.827-4.478.741-.447 1.516-1.12 1.55-1.936.034-.818-.876-1.691-1.573-2.374-4.167-4.086-1.392-12.751-.876-17.8.09-.907.18-1.803.281-2.699 3.168 6.214 9.087 16.368 14.41 17.913 5.718 1.612 11.233-15.438 13.805-24.529a18.642 18.642 0 0 0-4.347-2.34z"
                        fill="#2D5FFB"
                    />
                    <path
                        d="M213.552 113.79c-1.573-3.246.202-4.724.932-7.601a4.565 4.565 0 0 0-.247-3.27.337.337 0 0 0-.618.258c1.123 3.28-2.37 5.71-1.74 8.956.3.993.759 1.93 1.358 2.777a8.93 8.93 0 0 1 .831 7.422c-.056.213.27.37.371.157 1.483-3.269.562-5.676-.887-8.699zM219.673 116.365c-.36-2.093-1.617-3.772-1.539-5.967.09-2.586 1.37-5.53-.898-7.534a.293.293 0 0 0-.41-.05.29.29 0 0 0-.05.408c1.684 2.776.213 5.329.482 8.24.13.887.386 1.75.764 2.564a14.009 14.009 0 0 1 1.01 6.392c0 .19.282.224.338 0a8.739 8.739 0 0 0 .303-4.053z"
                        fill="#FFD600"
                    />
                </g>
                <path
                    stroke="#BDCCF9"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m263.158 20.38-1.599 5.997M244.291 25.46l4.394 4.383M239.255 44.338l5.993-1.613M253.088 58.14l1.6-5.998M271.955 53.06l-4.394-4.384M276.991 34.181l-5.993 1.613"
                />
                <path
                    stroke="#2D5FFB"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m251.5 14.65 4.013 14.914M233.498 32.691l14.924 3.981M240.123 57.301l10.91-10.934M264.747 63.87l-4.014-14.915M282.748 45.827l-14.924-3.98M276.123 21.218l-10.909 10.934"
                />
                <path
                    d="M241.302 21.798a1.225 1.225 0 1 1-2.367-.631 1.225 1.225 0 0 1 2.367.631M234.95 45.61a1.225 1.225 0 1 1-2.366-.63 1.225 1.225 0 0 1 2.367.63M283.51 33.056a1.225 1.225 0 1 1-2.368-.632 1.225 1.225 0 0 1 2.367.632M265.73 15.495a1.225 1.225 0 1 1-2.368-.631 1.225 1.225 0 0 1 2.367.631M252.8 63.972a1.225 1.225 0 1 1-2.367-.632 1.225 1.225 0 0 1 2.367.632M277.158 56.868a1.225 1.225 0 1 1-2.367-.631 1.225 1.225 0 0 1 2.367.631"
                    fill="#FCCB11"
                />
            </g>
        </svg>
    );
};

export const SvgIconSettings = () => {
    return (
        <svg
            width="23"
            height="23"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <filter
                    x="-12.9%"
                    y="-13.1%"
                    width="125.9%"
                    height="126.2%"
                    filterUnits="objectBoundingBox"
                    id="1xr910m69b"
                >
                    <feOffset dx="4" in="SourceAlpha" result="shadowOffsetInner1" />
                    <feComposite
                        in="shadowOffsetInner1"
                        in2="SourceAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                        result="shadowInnerInner1"
                    />
                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" in="shadowInnerInner1" />
                </filter>
                <path
                    d="M24.353 13.745c.204.128.376.3.504.503a3.283 3.283 0 0 0 3.784 1.378 1.603 1.603 0 0 1 2.08 1.744 3.283 3.283 0 0 0 2.013 3.488 1.603 1.603 0 0 1 .471 2.673 3.283 3.283 0 0 0-.699 3.966 1.603 1.603 0 0 1-1.357 2.35 3.283 3.283 0 0 0-3.085 2.589 1.603 1.603 0 0 1-2.55.928 3.283 3.283 0 0 0-4.028 0 1.603 1.603 0 0 1-2.55-.928 3.283 3.283 0 0 0-3.085-2.589 1.603 1.603 0 0 1-1.357-2.35 3.283 3.283 0 0 0-.7-3.966 1.603 1.603 0 0 1 .472-2.673 3.283 3.283 0 0 0 2.013-3.488 1.603 1.603 0 0 1 2.08-1.744 3.283 3.283 0 0 0 3.784-1.378 1.603 1.603 0 0 1 2.21-.503zm-.853 7.618a2.701 2.701 0 1 0 0 5.402 2.701 2.701 0 0 0 0-5.402z"
                    id="o0b3nlixsa"
                />
            </defs>
            <g transform="translate(-12.002 -12.16)" fill="none" fillRule="evenodd" strokeLinejoin="round">
                <use fill="#D5DFFE" xlinkHref="#o0b3nlixsa" />
                <use fill="#000" filter="url(#1xr910m69b)" xlinkHref="#o0b3nlixsa" />
                <use stroke="#111C5B" strokeWidth="1.3" xlinkHref="#o0b3nlixsa" />
            </g>
        </svg>
    );
};

export const SvgIconNotifications = () => {
    return <img src={s} />;
};

export const SvgIconArrowRightSecondary = () => {
    return <img className="h-10 w-10" src={rightSecondarySrc} />;
};

export const SvgIconArrowRightTertiary = () => {
    return <img className="h-5 w-5" src={rightTertiarySrc} />;
};

export const SvgIconArrowRight = () => {
    return <img className="h-10 w-10" src={rightSrc} />;
};

export const SvgIconFinishPrimary = () => {
    return <img src={finishPrimarySrc} />;
};

export const SvgIconFinishSecondary = () => {
    return <img className="h-10 w-10" src={finishSecondarySrc} />;
};

export const SvgIconPencilEdit = ({ className }: { className?: string }) => {
    return <img className={`h-6 w-6 ${className || ""}`} src={pencilEditSrc} />;
};

export const SvgIconPencilSign = () => {
    return <img src={pencilSignSrc} />;
};

export const SvgIconKnowledge = () => {
    return <img className="w-10 h-10" src={knowledgeSrc} />;
};
export const SvgIconKnowledgeOff = () => {
    return <img className="w-10 h-10" src={knowledgeOffSrc} />;
};

export const SvgIconDefaultAvatar = () => {
    return <img src={defaultAvatartSrc} />;
};

export const SvgIconLogo = () => {
    return <img src={logoSrc} />;
};

export const SvgResetIcon = () => {
    return <img src={reset} />;
};

export const SvgOvalActive = () => {
    return <img src={ovalActiveSrc} />;
}

export const SvgOvalPaused = () => {
    return <img src={ovalPausedSrc} />;
}

export const SvgPlay = () => {
    return <img className="w-6 h-6 text-white fill-white" src={playSrc} />;
}
